module.exports = __webpack_public_path__ + "img/gift.79340e57.svg";